export const romanNumberToArab = (roman: string): number => {
    if (!roman || typeof roman !== 'string') return 0

    const romanValues: Record<string, number> = {
        'I': 1,
        'V': 5,
        'X': 10,
        'L': 50,
        'C': 100,
        'D': 500,
        'M': 1000,
    }

    let result = 0
    const upperRoman = roman.toUpperCase()

    for (let i = 0; i < upperRoman.length; i++) {
        const current = romanValues[upperRoman[i]]
        const next = romanValues[upperRoman[i + 1]]

        if (next && current < next) {
            result += next - current
            i++
        } else {
            result += current
        }
    }

    return result
}
